import {useParams} from "react-router-dom";
import Page from "../Components/Page";

function AreaDetailPage() {
    const params = useParams();
    const endpoint = `/pages/areas/${params.type}`;

    return <Page endpoint={endpoint} />
}

export default AreaDetailPage;